import React, { useEffect, useState } from "react";
import { fetchContent } from "../../services/api";
import { DEFAULT_CONTENT } from "../../data/contentDefaults";
import "./MethodologyPage.css";

const STEP_ICONS = [
    `${process.env.PUBLIC_URL}/illustrations/method-data.svg`,
    `${process.env.PUBLIC_URL}/illustrations/method-composition.svg`,
    `${process.env.PUBLIC_URL}/illustrations/method-carbonation.svg`,
    `${process.env.PUBLIC_URL}/illustrations/method-spatial.svg`,
];

const MethodologyPage = ({ onChangeTab }) => {
    const [content, setContent] = useState(DEFAULT_CONTENT.methodology);

    useEffect(() => {
        let cancelled = false;

        fetchContent()
            .then((data) => {
                if (!cancelled && data?.methodology)
                    setContent(data.methodology);
            })
            .catch(() => {
                // Бэкенд недоступен — остаёмся на дефолтном тексте.
            });

        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <div className="page-shell methodology-page">
            <h1 className="page-heading">{content.heading}</h1>
            <p className="page-subheading">{content.subheading}</p>

            <div className="methodology-top">
                <div className="card methodology-steps-card">
                    <h3 className="methodology-steps-title">
                        {content.stepsTitle}
                    </h3>
                    <div className="methodology-steps">
                        {content.steps.map((step, i) => (
                            <React.Fragment key={`${step.title}-${i}`}>
                                <div className="methodology-step">
                                    <div className="methodology-step-head">
                                        <div className="methodology-step-index">
                                            {String(i + 1).padStart(2, "0")}
                                        </div>
                                        <img
                                            className="methodology-step-icon"
                                            src={
                                                STEP_ICONS[
                                                    i % STEP_ICONS.length
                                                ]
                                            }
                                            alt=""
                                            aria-hidden="true"
                                        />
                                    </div>
                                    <h4 className="methodology-step-title">
                                        {step.title}
                                    </h4>
                                    <p className="methodology-step-description">
                                        {step.description}
                                    </p>
                                </div>
                                {i < content.steps.length - 1 && (
                                    <span className="methodology-step-arrow">
                                        →
                                    </span>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </div>

                <div className="methodology-formula-card">
                    <h3 className="methodology-formula-title">
                        {content.formulaTitle}
                    </h3>
                    <div className="methodology-formula-images">
                        <img
                            className="methodology-formula-image"
                            src={`${process.env.PUBLIC_URL}/formula-epot.png`}
                            alt="Формула Epot — потенциал образования щелочности"
                        />
                        <img
                            className="methodology-formula-image"
                            src={`${process.env.PUBLIC_URL}/formula-cpot.png`}
                            alt="Формула Cpot — потенциал карбонизации минералов"
                        />
                    </div>
                    <div className="methodology-formula-divider" />
                    <div className="methodology-formula-result">
                        <span className="methodology-formula-result-label">
                            {content.resultLabel}
                        </span>
                        <div className="methodology-formula-result-values">
                            {content.resultValues.map((value, i) => (
                                <span key={i}>{value}</span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <p className="methodology-citation">
                {content.citation}{" "}
                <a
                    href={content.citationUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {content.citationUrl}
                </a>
            </p>

            <h2 className="methodology-quality-title">
                {content.qualityTitle}
            </h2>
            <div className="methodology-quality-grid">
                {content.qualityCards.map((item) => (
                    <div
                        className="card methodology-quality-card"
                        key={item.title}
                    >
                        <div className="methodology-quality-icon" />
                        <h4 className="methodology-quality-card-title">
                            {item.title}
                        </h4>
                        <p className="methodology-quality-card-description">
                            {item.description}
                        </p>
                        <button
                            type="button"
                            className="methodology-quality-link"
                            disabled={!item.targetTab}
                            onClick={() =>
                                item.targetTab && onChangeTab(item.targetTab)
                            }
                        >
                            {item.linkLabel}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MethodologyPage;
